const configuratorClass = document.getElementById("activeConfiguratorIcon").value;

const getActiveConfiguratorDepthIconClass = () => {
  switch (configuratorClass) {
    case "icon--point":
      return "icon--arbetsdjup-pinne";
    case "icon--disc":
      return "icon--working_depth_medium_1";
    case "icon--roller":
      return "icon--roller";
    default:
      return configuratorClass;
  }
};

const getActiveConfiguratorSizeIconClass = () => {
  switch (configuratorClass) {
    case "icon--point":
      return "icon--bredd";
    case "icon--disc":
      return "icon--tallriksdiameter";
    case "icon--roller":
      return "icon--roller";
    default:
      return configuratorClass;
  }
};

export { getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass }